/**
 * Logout button component
 * Triggers logout and redirects to login page
 */

import { useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/hooks/useAuth';

export function LogoutButton() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <Button variant="ghost" onClick={handleLogout} className="text-sm flex items-center gap-2">
      <LogOut className="h-4 w-4" />
      Sign out
    </Button>
  );
}
